import { useParams } from "react-router-dom";
import { useSEO } from "@/utils/seo";

/** `/__notfound/:section` 支持的分区标识与其对应列表页地址（需求 1.8、1.15、11.10、11.11）。 */
const SECTION_LIST_PATH: Record<string, string> = {
  generic: "/",
  solutions: "/solutions",
  products: "/products",
  cases: "/cases",
  news: "/news",
};

/**
 * 仅供预渲染使用的 404 变体页面。
 *
 * 该路由（`/__notfound/:section`）不出现在 sitemap 中，仅在构建期预渲染流程内被
 * 访问，用于生成 `404.html` 与 `solutions` / `products` / `cases` / `news` 四个分区
 * 变体，供部署层（nginx `error_page`）按路径前缀选用对应的提示文案与列表页链接。
 */
export default function NotFoundVariant() {
  const { section = "generic" } = useParams<{ section: string }>();
  const listPath = SECTION_LIST_PATH[section] ?? "/";

  useSEO({
    title: "页面未找到",
    description: "很抱歉，您访问的内容不存在或已被移除。",
    path: `/__notfound/${section}`,
    noindex: true,
  });

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">很抱歉，您访问的内容不存在或已被移除</h1>
        <p className="mt-4 text-base text-gray-500">
          您可以返回<a href={listPath} className="text-[#1a56db] hover:underline">列表页</a>
          查看其他内容，或
          <a href="/" className="text-[#1a56db] hover:underline">返回首页</a>。
        </p>
      </div>
    </div>
  );
}
